"use client";
import React from "react";
import { IconCheck } from "@tabler/icons-react";
import { plans } from "@/constants/tier";

export function PricingTable() {
  const features = [
    { title: "Unlimited API requests", included: true },
    { title: "Access to all endpoints", included: true },
    { title: "Priority email support", included: true },
    { title: "Advanced analytics", included: true },
    { title: "Custom integrations", included: true },
    { title: "Team collaboration", included: true },
    { title: "Access to Dashboard", included: true },
    { title: "Share functionality", included: true },
    { title: "Playground Editor", included: true },
    { title: "Marketplace access", included: true },
    { title: "On call support", included: true },
    { title: "Developer Program", included: true },
    { title: "Zero Downtime Guarantee", included: true },
    { title: "Custom Analytics", included: true },
  ];

  return (
    <div className="mx-auto w-full max-w-3xl relative z-20 px-4 py-20">
      <h2 className="text-2xl font-bold text-center text-neutral-900 dark:text-white mb-4">
        Everything included in all plans
      </h2>
      <p className="text-center text-neutral-600 dark:text-neutral-400 mb-12">
        Both monthly and yearly plans include all features
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {features.map((feature) => (
          <div
            key={feature.title}
            className="flex items-center gap-3 p-4 bg-white dark:bg-neutral-900 rounded-lg border border-neutral-200 dark:border-neutral-800"
          >
            <div className="flex-shrink-0 w-5 h-5 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center">
              <IconCheck className="w-3 h-3 text-green-600 dark:text-green-400" />
            </div>
            <span className="text-sm text-neutral-700 dark:text-neutral-300">
              {feature.title}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
